import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { localize } from 'vee-validate'

Vue.use(VueI18n)
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function getQueryStringParameterByName(name = null, url = null) {
  if (!url) {
    // eslint-disable-next-line no-param-reassign
    url = window.location.href
  }
  // eslint-disable-next-line no-param-reassign
  name = name.replace(/[[\]]/g, '\\$&')
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`)
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

const queryParamLocale = getQueryStringParameterByName('lang')

const locales = ['en', 'tr', 'ar', 'de', 'es', 'fr', 'pt', 'ru', 'ua']
const defaultLocale = 'en'

localize(defaultLocale)

let browserLocale = navigator.language || navigator.userLanguage
try {
  // eslint-disable-next-line prefer-destructuring
  browserLocale = browserLocale.split('-')[0]
} catch (e) {
  browserLocale = 'en'
}

let currentLocale = locales.includes(browserLocale) ? browserLocale : defaultLocale

if (locales.includes(queryParamLocale)) {
  currentLocale = queryParamLocale
} else if (locales.includes(localStorage.getItem('locale'))) {
  currentLocale = localStorage.getItem('locale')
}

export default new VueI18n({
  locale: currentLocale,
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
})
